export default {
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID,
  issuer: import.meta.env.VITE_OKTA_ISSUER,
  redirectUri: import.meta.env.VITE_OKTA_REDIRECT_URI,
  scopes: import.meta.env.VITE_OKTA_SCOPES.split(','),
  disableHttpsCheck: import.meta.env.VITE_OKTA_DISABLE_HTTPS_CHECK,
  pkce: true,
};
